<template>
<div class="activityEdit form" v-show="pageshow">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="135px" class="demo-ruleForm">
        <div class="activityMsgBox">
            <div class="title"><p>内容设置</p></div>
            <div class="contentBox">
                <div class="left">
                    <el-form-item label="活动封面" class="cover isRequired" prop="coveratturlid">
                        <div class="imgBox">
                            <i class="el-icon-picture" v-if="!ruleForm.eventsetting.logokeyurl"></i>
                            <img class="activityCoverImage" :src="ruleForm.eventsetting.logokeyurl + '?' + time"
                                 v-else-if="ruleForm.eventsetting && ruleForm.eventsetting.logokeyurl + '?' + time"
                                 alt="">
                        </div>
                        <div class="uploadFileBox" v-if="!isView">
                            <el-button @click.native="openDialog">选择文件</el-button>
                            <p>建议尺寸750*420px的JPG、PNG格式，<br> 图片小于2M。</p>
                        </div>
                    </el-form-item>
                    <el-form-item label="活动标题" prop="title" class="isRequired">
                        <el-input v-model="ruleForm.eventbaseinfo.eventname" maxlength="40" show-word-limit :disabled="!isAbled || isView"
                                  placeholder="输入活动标题，不超过40个字"></el-input>
                    </el-form-item>
                    <el-form-item label="活动详情" class="haveUEditor">
                        <uEditor :content="ruleForm.eventbaseinfo.eventdesp" ref="uEditor"
                                 @getUEditorContent="getTrySeeContent"></uEditor>
                    </el-form-item>
                </div>
                <div class="right">
                    <div class="topBox">
                        <img class="top" :src="require('@/common/images/toolmgt/view-top.png')" alt="">
                    </div>
                    <div class="innerBox">
                        <div class="coverImgBox" :style="'background:url('+ruleForm.eventsetting.logokeyurl + '?' + time+') 100%;background-size: 100%;'">
                            <div class="bg_bb_banner"></div>
                            <div class="brandBusiness">
                                <img :src="brandBusiness.logourl" alt="" class="headerImg">
                                <div class="brandBusinessinfo">
                                    <span class="hostname">{{brandBusiness.hostname}}</span>
                                    <div class="box">
                                        <span class="innerbox">粉丝：{{brandBusiness.followcount }} </span>
                                        <span class="innerbox"> 发起：{{brandBusiness.releasecount }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="eventinfo">
                            <div class="triangle"></div>
                            <div class="box">
                                <span class="type">商品零售</span>
                                <span class="eventname text-ellipse">{{ruleForm.eventbaseinfo.eventname}}</span>
                            </div>
                            <div class="time">时间：{{ruleForm.eventsetting.begintime}}~{{ruleForm.eventsetting.endtime}}</div>
                        </div>
                        <div class="countdown">
                            <span class="day">{{activetime.day}}</span>天
                            <span class="hour">{{activetime.hour}}</span>:
                            <span class="minute ">{{activetime.minute}}</span>:
                            <span class="second">{{activetime.second}}</span>后活动结束
                        </div>
                        <div class="detailsBox">
                            <div class="detailsContent" v-html="ruleForm.eventbaseinfo.eventdesp"
                                 v-if="ruleForm.eventbaseinfo.eventdesp"></div>
                        </div>
                        <div class="btns"></div>
                    </div>
                </div>
            </div>
        </div>
        <!--开团-->
        <div class="distributionMsgBox" v-if="eventsource==2">
            <div class="title"><p>团长分销设置</p></div>
            <div class="contentBox">
                <el-form-item label="活动时间" prop="date" class="date">
                    <el-date-picker v-model="ruleForm.eventsetting.begintime" :disabled="!isAbled||isView"
                                     type="datetime" placeholder="开始时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                    <span class="to">至</span>
                    <el-date-picker v-model="ruleForm.eventsetting.endtime" :disabled="!isAbled||isView"
                                    type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="结束时间"></el-date-picker>
                    <el-popover placement="right" trigger="hover" content="">
                        <div class="tipsP">
                            <p>活动开始后，活动时间不能修改</p>
                        </div>
                        <i class="el-icon-info" slot="reference"></i>
                    </el-popover>
                </el-form-item>
                <el-form-item label="是否允许用户进行分销">
                    <el-switch v-model="ruleForm.brandsetting.isdisevent" :disabled="!isAbled||isView" @change="setIsdisevent"></el-switch>
                    <el-popover placement="right" trigger="hover" content="">
                        <div class="tipsP">
                            <p>用户分享活动产生有效订单后，订单的商品佣金会分配给分享用户，团长只能获取团长佣金。</p>
                        </div>
                        <i class="el-icon-info" slot="reference"></i>
                    </el-popover>
                </el-form-item>
                <el-form-item label="是否关联全民分销" v-if="ruleForm.brandsetting.isdisevent" class="shiptype">
                    <el-switch v-model="ruleForm.brandsetting.disreltype" :disabled="!isAbled||isView" @change="setDisreltype"></el-switch>
                    <el-popover placement="right" trigger="hover" content="">
                        <div class="tipsP">
                            <p>开启关联全民分销后，订单的商品佣金会<span class="tc-red blod">优先</span>分配给全民分销活动的对应邀请人，团长只能获取团长佣金。</p>
                        </div>
                        <i class="el-icon-info" slot="reference"></i>
                    </el-popover>
                    <el-button type="success" @click="handleDisevent" v-if="ruleForm.brandsetting.disreltype && isAbled && !isView">请选择活动</el-button>
                    <span class="tc-red resulttypetip" v-if="ruleForm.brandsetting.disreleventid">已选择活动：{{ruleForm.brandsetting.diseventname}}</span>
                </el-form-item>
                <el-form-item label="佣金结款方式" required>
                    <el-radio-group v-model="ruleForm.brandsetting.settletype" :disabled="!isAbled||isView" @change="setSettletype">
                        <el-radio :label="1">顾客支付后立即结算</el-radio>
                        <el-radio :label="2" v-if="!ruleForm.brandsetting.isdisevent">团长活动结束并确认订单后结算</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否允许取消订单" v-if="ruleForm.brandsetting.settletype==2">
                    <el-switch v-model="ruleForm.brandsetting.isrefund" ::disabled="!isAbled||isView"></el-switch>
                </el-form-item>
                <el-form-item label="取消订单时间期限" v-if="ruleForm.brandsetting.isrefund">
                    <el-select v-model="ruleForm.brandsetting.refunddays" placeholder="请选择" @change="setRefundtimetype" :disabled="!isAbled||isView">
                        <el-option v-for="(obj,index) in refundtimetypeList" :key="index" :label="obj.name" :value="obj.value"></el-option>
                    </el-select>
                    <el-popover placement="right" trigger="hover" content="">
                        <div class="tipsP">
                            <p>活动开始后不能修改开始时间，截止时间可以改</p>
                        </div>
                        <i class="el-icon-info" slot="reference"></i>
                    </el-popover>
                </el-form-item>
                <el-form-item label="凭证类型" required>
                    <el-radio-group v-model="ruleForm.brandsetting.resulttype" :disabled="!isAbled||isView">
                        <el-radio :label="5">物流发货</el-radio>
                        <el-radio :label="1">普通凭证</el-radio>
                        <el-radio :label="4">普通核销码</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="选择团长" v-if="(ruleForm.brandsetting.resulttype==1 || ruleForm.brandsetting.resulttype==4)">
                    <el-button type="success" @click="handleLeader" v-if="!isView">请选择团长</el-button>
                    <span class="tc-red resulttypetip" v-if="ruleForm.brandsetting.headerlist.length">{{_computedTip}}</span>
                </el-form-item>
                <el-form-item label="物流方式" required  class="shiptype" v-if="ruleForm.brandsetting.resulttype==5">
                    <el-radio-group v-model="ruleForm.brandsetting.shiptype" :disabled="!isAbled||isView">
                        <el-radio :label="1">
                            <span>快递发货到顾客</span>
                            <el-button type="success" @click="handleLeader" v-if="ruleForm.brandsetting.shiptype==1 && !isView">请选择团长</el-button>
                            <span class="tc-red resulttypetip" v-if="ruleForm.brandsetting.shiptype==1&&ruleForm.brandsetting.headerlist.length">{{_computedTip}}</span>
                        </el-radio>
                        <el-radio :label="3">
                            <span>发货到团长提货点，顾客自提</span>
                            <el-button type="success" @click="handleAddr" v-if="ruleForm.brandsetting.shiptype==3 && !isView">请选择提货点</el-button>
                            <span class="tc-red resulttypetip" v-if="ruleForm.brandsetting.shiptype==3&&ruleForm.brandsetting.headerlist.length">{{_computedTip}}</span>
                        </el-radio>
                        <el-radio :label="2">
                            <span>指定品牌商提货点，顾客自提</span>
                            <el-button type="success"  @click="handleLeaderAndAddr"  v-if="ruleForm.brandsetting.shiptype==2 && !isView">请选择团长+提货点</el-button>
                            <span class="tc-red resulttypetip" v-if="ruleForm.brandsetting.shiptype==2">{{_computedTip}}</span>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="活动可参与次数" prop="brandsetting.maxjoincount">
                    <el-input v-model="ruleForm.brandsetting.maxjoincount" :disabled="!isAbled || isView"
                             :placeholder="maxjoincoun==0?'不限':'输入活动可参与次数'"></el-input>
                </el-form-item>
                <el-form-item label="商品起购价" prop="brandsetting.minordermoney" class="minordermoneyBox">
                    <el-input v-model="ruleForm.brandsetting.minordermoney" :disabled="!isAbled || isView"
                              placeholder="输入商品起购价"><template slot="append">元</template></el-input>
                    <el-select v-model="ruleForm.brandsetting.minordermoneytype" placeholder="请选择" :disabled="!isAbled||isView">
                        <el-option v-for="(obj,index) in minordermoneytypeList" :key="index" :label="obj.name" :value="obj.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="向订阅团长发送通知">
                    <el-switch v-model="ruleForm.brandsetting.issubnotify" :disabled="!isAbled||isView"></el-switch>
                </el-form-item>
                <el-form-item label="允许团长选择商品开团">
                    <el-switch v-model="ruleForm.brandsetting.iscustomproduct" :disabled="!isAbled||isView"></el-switch>
                </el-form-item>
                <el-form-item label="允许品牌商修改团长活动内容">
                    <el-switch v-model="ruleForm.brandsetting.ismodifyheadercontent"
                               :disabled="!isAbled||isView"></el-switch>
                </el-form-item>
                <el-form-item label="允许团长修改活动标题">
                    <el-switch v-model="ruleForm.brandsetting.ismodifyevent" :disabled="!isAbled||isView"></el-switch>
                </el-form-item>
            </div>
        </div>
        <!--模板-->
        <div class="distributionMsgBox"  v-if="eventsource==3">
            <div class="title"><p>活动模板设置</p></div>
            <div class="contentBox">
                <el-form-item label="凭证类型" required>
                    <el-radio-group v-model="ruleForm.commonsaleinfo.productsendtype">
                        <el-radio :label="5">物流发货</el-radio>
                        <el-radio :label="1">普通凭证</el-radio>
                        <el-radio :label="4">普通核销码</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="物流方式" required  class="shiptype" v-if="ruleForm.commonsaleinfo.productsendtype==5">
                    <el-radio-group v-model="ruleForm.commonsaleinfo.resultshiptype">
                        <el-radio :label="1">快递发货到顾客</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="活动可参与次数" prop="providersetting.maxjoincount">
                    <el-input v-model="ruleForm.providersetting.maxjoincount"
                              placeholder="输入活动可参与次数"></el-input>
                </el-form-item>
                <el-form-item label="商品起购价" prop="providersetting.minordermoney" class="minordermoneyBox">
                    <el-input v-model="ruleForm.providersetting.minordermoney"
                              placeholder="输入商品起购价"><template slot="append">元</template></el-input>
                    <el-select v-model="ruleForm.providersetting.minordermoneytype" placeholder="请选择">
                        <el-option v-for="(obj,index) in minordermoneytypeList" :key="index" :label="obj.name" :value="obj.value"></el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="允许发布方修改活动内容">-->
                    <!--<el-switch v-model="ruleForm.providersetting.ismodifyevent" :disabled="!isAbled"></el-switch>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="向订阅绑定发布方发送通知">-->
                    <!--<el-switch v-model="ruleForm.providersetting.issubnotify" :disabled="!isAbled"></el-switch>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="允许服务商修改发布方活动内容">-->
                    <!--<el-switch v-model="ruleForm.providersetting.ismodifyhostcontent"-->
                               <!--:disabled="!isAbled"></el-switch>-->
                <!--</el-form-item>-->
            </div>
        </div>
        <div class="disFrom">
            <div class="title">
                <p>{{eventsource==2?'零售表单':'活动表单'}}<el-switch v-model="showDistributionForm"></el-switch></p>
            </div>
            <div class="contentBox" v-show="showDistributionForm">
                <el-form-item label="表单类型" class="optionsBox" v-if="!isView">
                    <div class="flex">
                        <div class="formOptions">
                            <div @click="addInput(obj)" v-for="(obj,i) in formOptions" :key="i">
                                <img :src="obj.icon" alt="">
                                <div class="name">{{obj.name}}</div>
                            </div>
                        </div>
                        <div class="tips">点击相应表单类型即可新增</div>
                    </div>
                </el-form-item>
                <el-form-item label="表单项目" class="formItem" v-for="(item, index) in ruleForm.enrollform"
                              :key="index">
                    <div>
                        <div class="input" v-show="item.coltype === 1">
                            <div class="optionsName">{{index+1}}、填写项
                                <input type="text" v-model="item.colname" :disabled="isView" placeholder="请输入填写项内容">
                            </div>
                            <div class="choiceBox">
                                <el-radio-group v-model="item.isnotnull" :disabled="isView">
                                    <el-radio :label="obj.code" v-for="(obj,i) in isnotnullList" :key="i">{{obj.name}}</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="choiceBox">
                                <el-radio-group v-model="item.ispublictype" :disabled="isView">
                                    <el-radio :label="obj.code" v-for="(obj,i) in publictypeList" :key="i">{{obj.name}}</el-radio>
                                </el-radio-group>
                            </div>
                            <img @click="deleteOptions(index)"  v-if="!isView"
                                 src="../../../../common/images/nationalDistributionMenu/delete_form_item.png"
                                 alt="">
                        </div>
                        <div class="randio" v-show="item.coltype === 6">
                            <div class="optionsName">{{index+1}}、单选项 <input type="text" v-model="item.colname"
                                                                            placeholder="请输入单选项内容"></div>
                            <div class="choiceItem" v-for="(obj, i) in item.optionsinfo" :key="i">
                                <input type="text" placeholder="选项" v-model="obj.optionsName" :disabled="isView">
                                <div class="delete" @click="deleteOptionsName(index)" v-if="!isView"
                                     v-show="i === item.optionsinfo.length-1">移除
                                </div>
                            </div>
                            <div class="newOptions" @click="addOptions(index)">+新选项</div>
                            <div class="choiceBox">
                                <el-radio-group v-model="item.isnotnull" :disabled="isView">
                                    <el-radio :label="obj.code" v-for="(obj,i) in isnotnullList" :key="i">{{obj.name}}</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="choiceBox">
                                <el-radio-group v-model="item.ispublictype" :disabled="isView">
                                    <el-radio :label="obj.code" v-for="(obj,i) in publictypeList" :key="i">{{obj.name}}</el-radio>
                                </el-radio-group>
                            </div>
                            <img @click="deleteOptions(index)"  v-if="!isView"
                                 src="../../../../common/images/nationalDistributionMenu/delete_form_item.png"
                                 alt="">
                        </div>
                        <div class="checkbox" v-show="item.coltype === 7">
                            <div class="optionsName">{{index+1}}、多选项 <input type="text" v-model="item.colname"
                                                                            placeholder="请输入多选项内容"></div>
                            <div class="choiceItem" v-for="(obj, i) in item.optionsinfo" :key="i">
                                <input type="text" placeholder="选项" v-model="obj.optionsName" :disabled="isView">
                                <div class="delete" @click="deleteOptionsName(index)" v-if="!isView"
                                     v-show="i === item.optionsinfo.length-1">移除
                                </div>
                            </div>
                            <div class="newOptions" @click="addOptions(index)">+新选项</div>
                            <div class="choiceBox">
                                <el-radio-group v-model="item.isnotnull" :disabled="isView">
                                    <el-radio :label="obj.code" v-for="(obj,i) in isnotnullList" :key="i">{{obj.name}}</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="choiceBox">
                                <el-radio-group v-model="item.ispublictype" :disabled="isView">
                                    <el-radio :label="obj.code" v-for="(obj,i) in publictypeList" :key="i">{{obj.name}}</el-radio>
                                </el-radio-group>
                            </div>
                            <img @click="deleteOptions(index)"  v-if="!isView"
                                 src="../../../../common/images/nationalDistributionMenu/delete_form_item.png"
                                 alt="">
                        </div>
                        <div class="select" v-show="item.coltype === 8">
                            <div class="optionsName">{{index+1}}、菜单项 <input type="text" v-model="item.colname"
                                                                            placeholder="请输入菜单项内容"></div>
                            <div class="choiceItem" v-for="(obj, i) in item.optionsinfo" :key="i">
                                <input type="text" placeholder="选项" v-model="obj.optionsName"  :disabled="isView">
                                <div class="delete" @click="deleteOptionsName(index)" v-if="!isView"
                                     v-show="i === item.optionsinfo.length-1">移除
                                </div>
                            </div>
                            <div class="newOptions" @click="addOptions(index)">+新选项</div>
                            <div class="choiceBox">
                                <el-radio-group v-model="item.isnotnull" :disabled="isView">
                                    <el-radio :label="obj.code" v-for="(obj,i) in isnotnullList" :key="i">{{obj.name}}</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="choiceBox">
                                <el-radio-group v-model="item.ispublictype" :disabled="isView">
                                    <el-radio :label="obj.code" v-for="(obj,i) in publictypeList" :key="i">{{obj.name}}</el-radio>
                                </el-radio-group>
                            </div>
                            <img @click="deleteOptions(index)" v-if="!isView"
                                 src="../../../../common/images/nationalDistributionMenu/delete_form_item.png"
                                 alt="">
                        </div>
                    </div>
                </el-form-item>
            </div>
        </div>
        <el-form-item class="btnBox">
            <el-button @click="cancel">{{isView?'返回':'取消发布'}}</el-button>
            <el-button type="primary" plain @click="submitDart" v-if="isAbled&&(isCreate || this.ruleForm.eventbaseinfo.status==9)">存为草稿</el-button>
            <el-button type="primary" @click="submitForm" v-if="!isView">发布活动</el-button>
        </el-form-item>
    </el-form>
    <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage"
                      :uploadType="uploadType"></ShopLocalCropper>
    <leaderListDialog ref="leaderListDialog" @setLeaderList="_setLeaderList"></leaderListDialog>
    <addrListDialog ref="addrListDialog" @setAddrList="_setAddrList"></addrListDialog>
    <leaderAndAddrDialog ref="leaderAndAddrDialog" @setLeaderAddrList="_setLeaderAddrList"></leaderAndAddrDialog>
    <successDialog ref="successDialog" :hostroletype="hostroletype"></successDialog>
    <distributionListDialog ref="distributionListDialog" @setDisreleventid="_setDisreleventid"></distributionListDialog>
</div>
</template>
<script>
import UEditor from 'base/uEditor/uEditor2'
import {mapGetters, mapActions} from 'vuex'
import {computeFileSize} from 'common/js/tools'
import {uploadReleaseEvent, getEventReleaseInfo, uploadProviderReleaseEvent, getProviderEventReleaseInfo} from 'api/brandBusiness'
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import LeaderListDialog from 'views/brandBusiness/activityMgt/activity/components/leaderListDialog.vue'
import AddrListDialog from 'views/brandBusiness/activityMgt/activity/components/addrListDialog.vue'
import LeaderAndAddrDialog from 'views/brandBusiness/activityMgt/activity/components/leaderAndAddrDialog.vue'
import SuccessDialog from 'views/brandBusiness/activityMgt/activity/components/successDialog.vue'
import DistributionListDialog from 'views/brandBusiness/activityMgt/activity/components/distributionListDialog.vue'
export default {
    name: 'activityEdit',
    data() {
        return {
            activetime: {
                day: 0,
                hour: 0,
                minute: 0,
                second: 0
            },
            formOptions: [
                {coltype: 1, name: '填写项', icon: require('@/common/images/nationalDistributionMenu/input.png')},
                {coltype: 6, name: '单选项', icon: require('@/common/images/nationalDistributionMenu/randio.png')},
                {coltype: 7, name: '多选项', icon: require('@/common/images/nationalDistributionMenu/checkbox.png')},
                {coltype: 8, name: '菜单项', icon: require('@/common/images/nationalDistributionMenu/select.png')},
            ],
            isnotnullList: [
                {code: 1, name: '必填'},
                {code: 0, name: '非必填'}
            ],
            publictypeList: [
                {code: 1, name: '全部公开', ispublic: 1, publictype: 1},
                {code: 2, name: '全部隐藏', ispublic: 0, publictype: 1},
                {code: 3, name: '部分隐藏', ispublic: 1, publictype: 2}
            ],
            showDistributionForm: false, // 分销表单展开收起
            refundtimetypeList: [
                { code: 1, name: '活动结束前可退款', cls: '', value: 0},
                { code: 2, name: '活动结束后1天可退款', cls: '', value: 1},
                { code: 2, name: '活动结束后2天可退款', cls: '', value: 2},
                { code: 2, name: '活动结束后3天可退款', cls: '', value: 3},
                { code: 2, name: '活动结束后4天可退款', cls: '', value: 4},
                { code: 2, name: '活动结束后5天可退款', cls: '', value: 5},
                { code: 2, name: '活动结束后6天可退款', cls: '', value: 6},
                { code: 2, name: '活动结束后7天可退款', cls: '', value: 7}
            ],
            minordermoneytypeList: [
                { code: 1, name: '首次参与需达到起购价', cls: '', value: 1},
                { code: 2, name: '每次参与均需达到起购价', cls: '', value: 2}
            ],
            pageshow: false,
            time: new Date().getTime(),
            ruleForm: {
                brandsetting: {
                    headerlist: [
                        // {
                        //     headerid: '',
                        //     pplist: ''
                        // }
                    ],
                    iscustomproduct: false,
                    ismodifyevent: false,
                    ismodifyheadercontent: false,
                    isopenheader: false,
                    isrefund: false,
                    issubnotify: false,
                    ppidlist: '',
                    refunddays: 0,
                    refundtimetype: 0,
                    resulttype: 5,
                    settletype: 1,
                    shiptype: 1,
                    isdisevent: false,
                    maxjoincount: '', // 每人可参与次数，0为不限制
                    minordermoney: 0, // 订单起购价，默认为0
                    minordermoneytype: 1, // 订单起购价类型，1首次参与需达到起购价  2每次参与均需达到起购价
                    disreltype: false, // 0 分享绑定 1从全民分销绑定
                    disreleventid: '',
                    diseventname: ''
                },
                commonsaleinfo: {
                    productlist: [],
                    productsendtype: 5,
                    resultshiptype: 1
                },
                enrollform: [
                    // {
                    //     colindex: 0,
                    //     colinnerid: '',
                    //     colname: '',
                    //     coltype: 1,
                    //     isnotnull: 0,
                    //     ispublic: 0,
                    //     optionsinfo: [],
                    //     placeholder: '',
                    //     publictype: 0
                    // }
                ],
                eventbaseinfo: {
                    eventcontent: [],
                    eventdesp: '',
                    eventid: '',
                    eventname: '',
                    eventsource: 2, // 1普通 2开团 3模板 4复制 5从服务商复制
                    eventtype: 10,
                    fromeventid: '',
                    hostroletype: 2, // 1普通 2品牌商 3团长 4服务商
                    isdraft: 0,
                    rolehostinnerid: ''
                },
                eventsetting: {
                    address: '',
                    address01: '',
                    begintime: '',
                    commentordertype: 0,
                    commentpritype: 0,
                    endtime: '',
                    fansguidecontent: '',
                    fansguideimgid: '',
                    fansguideimgurl: '',
                    fansguidename: '',
                    iscomment: 0,
                    isjoinaward: 0,
                    isopenfansguide: '',
                    isrefund: 0,
                    isshareaward: 0,
                    joinawardtotalcount: 0,
                    joinawardtotalmoney: 0,
                    logokeyid: '',
                    logokeyurl: '',
                    privacy: 0,
                    shareawardsinglemoney: 0,
                    shareawardtotalcount: 0
                },
                providersetting: {
                    ismodifyevent: 1,
                    ismodifyhostcontent: 1,
                    issubnotify: 1,
                    maxjoincount: '', // 每人可参与次数，0为不限制
                    minordermoney: 0, // 订单起购价，默认为0
                    minordermoneytype: 1, // 订单起购价类型，1首次参与需达到起购价  2每次参与均需达到起购价
                }
            },
            rules: {
                'brandsetting.maxjoincount': [
                    {pattern: /^[1-9]\d*|0$/, message: '请输入整数', trigger: 'blur'}
                ],
                'brandsetting.minordermoney': [
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ],
                'providersetting.maxjoincount': [
                    {pattern: /^[1-9]\d*|0$/, message: '请输入整数', trigger: 'blur'}
                ],
                'providersetting.minordermoney': [
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ]
            },
            publicPath: process.env.BASE_URL,
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [750, 420], // 截图框的宽高比例
                enlarge: 4.4, // 图片根据截图框输出比例倍数
                autoCropWidth: 225, // 默认生成截图框宽度
                autoCropHeight: 126 // 默认生成截图框高度
            },
            isAbled: true,
            isCreate: true,
            fromeventid: this.$route.query.fromeventid ? this.$route.query.fromeventid : '',
            eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
            eventsource: this.$route.query.eventsource ? this.$route.query.eventsource : 2, // 1普通 2开团 3模板 4复制开团 5从服务商复制
            hostroletype: this.$route.query.hostroletype ? this.$route.query.hostroletype : 2, // 2 品牌商  4 服务商
            timer: null,
            isView: this.$route.query.isView ? this.$route.query.isView : false,
            maxjoincoun: -1 // 0 不限
        }
    },
    created() {
    },
    mounted() {
        if (this.eventid) {
            if (this.hostroletype == 2) {
                this.getView()
            } else if (this.hostroletype == 4) {
                this.getView2()
            }
        } else {
            this.pageshow = true
            this._setBegintimeEndtime()
        }
    },
    beforeRouteLeave(to, form, next) {
        clearInterval(this.timer)
        next()
    },
    methods: {
        setDisreltype() {
            this.ruleForm.brandsetting.disreleventid = ''
        },
        _setDisreleventid(selectedResult) {
            this.ruleForm.brandsetting.disreleventid = selectedResult.disreleventid
            this.ruleForm.brandsetting.diseventname = selectedResult.diseventname
        },
        _setBegintimeEndtime() {
            let date = new Date()
            let sevenDate = new Date().getTime()
            sevenDate = sevenDate + 86400000 * 7
            sevenDate = new Date(sevenDate)
            this.ruleForm.eventsetting.begintime = this.formattingTime(date)
            this.ruleForm.eventsetting.endtime = this.formattingTime(sevenDate)
            this._countdown()
            this.timer = setInterval(() => {
                this._countdown()
            }, 1000)
        },
        _countdown() {
            let currenttime = new Date().getTime()
            let endtime = new Date(this.ruleForm.eventsetting.endtime).getTime()
            if (currenttime > endtime) {
                clearInterval(this.timer)
                this.activetime.day = 0
                this.activetime.hour = 0
                this.activetime.minute = 0
                this.activetime.second = 0
                return false
            }
            let day = parseInt((endtime - currenttime) / 1000 / 60 / 60 / 24)
            let hour = parseInt((endtime - currenttime) / 1000 / 60 / 60)
            let minute = parseInt((endtime - currenttime) / 1000 / 60)
            let second = parseInt((endtime - currenttime) / 1000)
            this.activetime.day = day
            this.activetime.hour = hour - day * 24
            this.activetime.minute = minute - hour * 60
            this.activetime.second = second - minute * 60
        },
        handleLeader() {
            this.$refs.leaderListDialog.openDialog(this.ruleForm.brandsetting.headerlist, this.isCreate? '': this.eventid)
        },
        handleDisevent() {
            this.$refs.distributionListDialog.openDialog(this.ruleForm.brandsetting.disreleventid, this.ruleForm.brandsetting.diseventname)
        },
        handleAddr() {
            this.$refs.addrListDialog.openDialog(this.ruleForm.brandsetting.headerlist, this.isCreate? '': this.eventid)
        },
        handleLeaderAndAddr() {
            this.$refs.leaderAndAddrDialog.openDialog(this.ruleForm.brandsetting.headerlist, this.ruleForm.brandsetting.ppidlist, this.isCreate? '': this.eventid)
        },
        _setLeaderList(headerlist) {
            this.ruleForm.brandsetting.headerlist = headerlist
        },
        _setAddrList(addrlist) {
            this.ruleForm.brandsetting.headerlist = addrlist
        },
        _setLeaderAddrList(headerlist, addrlist) {
            this.ruleForm.brandsetting.headerlist = headerlist
            this.ruleForm.brandsetting.ppidlist = addrlist
        },
        setIsdisevent() {
            this.ruleForm.brandsetting.settletype = 1
            this.ruleForm.brandsetting.refundtimetype = 1
            this.ruleForm.brandsetting.refunddays = 0
            this.ruleForm.brandsetting.isrefund = 0
            this.ruleForm.brandsetting.disreltype = false
            this.ruleForm.brandsetting.disreleventid = ''
            this.ruleForm.brandsetting.diseventname = ''
        },
        setSettletype() {
            this.ruleForm.brandsetting.refundtimetype = 1
            this.ruleForm.brandsetting.refunddays = 0
            this.ruleForm.brandsetting.isrefund = 0
        },
        setRefundtimetype(val) {
            this.ruleForm.brandsetting.refundtimetype = this.refundtimetypeList[val].code
        },
        // 格式化时间
        formattingTime(d) {
            let date = new Date(d)
            var YY = date.getFullYear() + '-'
            var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
            var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            // return YY + MM + DD + " " + hh + mm + ss
            return YY + MM + DD + " " + hh + mm
        },
        // 增加填写项
        addInput(obj) {
            let optionsinfo = []
            if ([6,7,8].indexOf(obj.coltype) > -1) {
                optionsinfo = [{optionsName: ''}]
            }
            let item = {
                colinnerid: '',
                coltype: obj.coltype,
                colname: '',
                isnotnull: 1, // 1必填 0 非必填
                colindex: 0,
                ispublictype: 1, // 1全部隐藏 2全部公开 3部分隐藏
                ispublic: 1, // 0全部隐藏 1全部公开 1部分隐藏
                optionsinfo: optionsinfo,
                placeholder: '',
                publictype: 1 // 1 全部隐藏 全部公开 2部分隐藏
            }
            this.ruleForm.enrollform.push(item)
        },
        // 增加新选项
        addOptions(index) {
            this.ruleForm.enrollform[index].optionsinfo.push({optionsName: ''})
        },
        // 删除表单项目
        deleteOptions(index) {
            this.ruleForm.enrollform.splice(index, 1)
        },
        // 移除选项
        deleteOptionsName(index) {
            this.ruleForm.enrollform[index].optionsinfo.pop()
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        _setImage(file) {
            this.time = new Date().getTime()
            this.ruleForm.eventsetting.logokeyurl = file.furl
            this.ruleForm.eventsetting.logokeyid = file.key
        },
        submitDart() {
            this.ruleForm.eventbaseinfo.isdraft = 1
            this.submit()
        },
        submitForm() {
            this.ruleForm.eventbaseinfo.isdraft = 0
            this.submit()
        },
        submit() {
            if (this.ruleForm.brandsetting.isdisevent && this.ruleForm.brandsetting.disreltype && !this.ruleForm.brandsetting.disreleventid) {
                this.$message.error('请选择分销活动')
                return false
            }
            if (this.eventsource == 2) {
                // 如果不选择提货点，通过活动邀请团长后将无法购买 20200703
                // 通过活动直接邀请团长，直接成为团长开团，如果没有提货点，用户购买会报错 20200703
                let list = this.ruleForm.brandsetting.ppidlist ? this.ruleForm.brandsetting.ppidlist.split(','): []
                if (this.ruleForm.brandsetting.shiptype == 2 && !list.length) {
                    this.$message.error('请选择品牌商自提点')
                    return false
                }
                let flag = true
                if (this.ruleForm.brandsetting.shiptype == 3 && this.ruleForm.brandsetting.headerlist.length) {
                    this.ruleForm.brandsetting.headerlist.forEach(obj => {
                        if (!obj.pplist) {
                            this.$message.error('请选择团长自提点')
                            flag = false
                            return false
                        }
                    })
                }
                if (!flag) return false
                if (!this.ruleForm.brandsetting.headerlist.length) {
                    let tip = ''
                    if (this.ruleForm.brandsetting.shiptype == 1) {
                        tip = '您当前未选择团长，活动无法被正常复制，继续保存吗'
                    } else if (this.ruleForm.brandsetting.shiptype == 2) {
                        tip = '您当前未选择团长，活动无法被正常复制，继续保存吗'
                    } else {
                        tip = '您当前未选择提货点，活动无法被正常复制，继续保存吗'
                    }
                    this.$confirm(tip, '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._submit()
                    })
                } else {
                    this._submit()
                }
            } else {
                this._submit()
            }
        },
        _submit() {
            this.$refs.ruleForm.validate((valid, name) => {
                if (valid) {
                    let obj = $.extend(true, {}, this.ruleForm )
                    obj.brandsetting.iscustomproduct = obj.brandsetting.iscustomproduct ? 1 : 0
                    obj.brandsetting.ismodifyevent = obj.brandsetting.ismodifyevent ? 1 : 0
                    obj.brandsetting.ismodifyheadercontent = obj.brandsetting.ismodifyheadercontent ? 1 : 0
                    obj.brandsetting.isopenheader = obj.brandsetting.isopenheader ? 1 : 0
                    obj.brandsetting.isrefund = obj.brandsetting.isrefund ? 1 : 0
                    obj.brandsetting.issubnotify = obj.brandsetting.issubnotify ? 1 : 0
                    obj.brandsetting.isdisevent = obj.brandsetting.isdisevent  ? '1' : '0'
                    obj.brandsetting.disreltype = obj.brandsetting.disreltype  ? 1 : 0
                    obj.brandsetting.maxjoincount = obj.brandsetting.maxjoincount ? obj.brandsetting.maxjoincount : 0
                    obj.providersetting.ismodifyevent = obj.providersetting.ismodifyevent ? 1 : 0
                    obj.providersetting.ismodifyhostcontent = obj.providersetting.ismodifyhostcontent ? 1 : 0
                    obj.providersetting.issubnotify = obj.providersetting.issubnotify ? 1 : 0
                    obj.providersetting.maxjoincount = obj.providersetting.maxjoincount ? obj.providersetting.maxjoincount : 0
                    obj.eventbaseinfo.eventsource = this.eventsource
                    if (obj.brandsetting.shiptype == 1) {
                        obj.brandsetting.headerlist.forEach(obj2 => {
                            obj2.pplist = ''
                        })
                        obj.brandsetting.ppidlist = ''
                    } else if (obj.brandsetting.shiptype == 2) {
                        obj.brandsetting.headerlist.forEach(obj2 => {
                            obj2.pplist = ''
                        })
                    } else if (obj.brandsetting.shiptype == 3) {
                        obj.brandsetting.ppidlist = ''
                    }
                    if (!this._setForm(obj)) return false
                    obj.eventbaseinfo.hostroletype = this.hostroletype
                    if (this.hostroletype == 2) {
                        obj.eventbaseinfo.rolehostinnerid = this.brandBusiness.hostid
                        this._uploadReleaseEvent(obj)
                    } else if (this.hostroletype == 4) {
                        obj.eventbaseinfo.rolehostinnerid = this.user.providerinnerid
                        this._uploadProviderReleaseEvent(obj)
                    }
                }
            })
        },
        cancel() {
            this.$router.back()
        },
        getTrySeeContent(content) {
            this.ruleForm.eventbaseinfo.eventdesp = content
        },
        _uploadReleaseEvent(obj) {
            this.setLoading(true)
            uploadReleaseEvent({
                data: Object.assign({}, obj),
                success: data => {
                    this.setLoading(false)
                    if (this.isCreate) {
                        this.setIsRefresh(2)
                    } else {
                        this.setIsRefresh(1)
                    }
                    this.$refs.successDialog.openDialog(data.data.eventinnerid, data.data.eventdetailurl, data.data.hostrolepageurl, this.hostroletype)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _uploadProviderReleaseEvent(obj) {
            this.setLoading(true)
            uploadProviderReleaseEvent({
                data: Object.assign({}, obj),
                success: data => {
                    this.setLoading(false)
                    if (this.isCreate) {
                        this.setIsRefresh(2)
                    } else {
                        this.setIsRefresh(1)
                    }
                    this.$refs.successDialog.openDialog(data.data.eventinnerid, data.data.eventdetailurl, data.data.hostrolepageurl, this.hostroletype)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取活动详情
        getView() {
            this.setLoading(true)
            getEventReleaseInfo({
                data: {eventid: this.eventid, eventtype: 10},
                success: data => {
                    this.setLoading(false)
                    if (data.data.enrollform) {
                        if (data.data.enrollform.length) this.showDistributionForm = true
                        data.data.enrollform.some((obj, index) => {
                            let tmp = []
                            if (obj.ispublic == 1 && obj.publictype ==1){
                                obj.ispublictype = 1
                            } else if (obj.ispublic == 0 && obj.publictype ==1) {
                              obj.ispublictype = 2
                            } else if (obj.ispublic == 1 && obj.publictype ==2) {
                                obj.ispublictype = 3
                            }
                            obj.optionsinfo = obj.optionsinfo ? obj.optionsinfo.split(',') : []
                            obj.optionsinfo.forEach(obj2 => {
                                tmp.push({optionsName: obj2})
                            })
                            obj.optionsinfo = tmp
                        })
                    }
                    this.maxjoincoun = data.data.brandsetting.maxjoincount
                    data.data.eventbaseinfo.fromeventid = this.fromeventid
                    data.data.brandsetting.iscustomproduct = !!data.data.brandsetting.iscustomproduct
                    data.data.brandsetting.ismodifyevent = !!data.data.brandsetting.ismodifyevent
                    data.data.brandsetting.ismodifyheadercontent = !!data.data.brandsetting.ismodifyheadercontent
                    data.data.brandsetting.isopenheader = !!data.data.brandsetting.isopenheader
                    data.data.brandsetting.isrefund = !!data.data.brandsetting.isrefund
                    data.data.brandsetting.issubnotify = !!data.data.brandsetting.issubnotify
                    data.data.brandsetting.disreltype = !!data.data.brandsetting.disreltype
                    data.data.brandsetting.isdisevent = data.data.brandsetting.isdisevent == '0' ? false : true
                    data.data.brandsetting.maxjoincount = data.data.brandsetting.maxjoincount ? data.data.brandsetting.maxjoincount : ''
                    if (this.eventsource == 2 && [0, 9].indexOf(data.data.eventbaseinfo.status) > -1 && !this.fromeventid) {
                        data.data.eventbaseinfo.eventid = this.eventid
                        this.isAbled = true
                        this.isCreate = false
                        this.ruleForm = data.data
                    } else if (this.eventsource == 2 && this.fromeventid) {
                        this.isAbled = true
                        this.isCreate = true
                        data.data.brandsetting = this.ruleForm.brandsetting
                        this.ruleForm = data.data
                        this._setBegintimeEndtime()
                    } else {
                        data.data.eventbaseinfo.eventid = this.eventid
                        this.isAbled = false
                        this.isCreate = false
                        this.ruleForm = data.data
                    }
                    this._countdown()
                    this.timer = setInterval(() => {
                        this._countdown()
                    }, 1000)
                    this.pageshow = true
                    this.$nextTick(() => {
                        this.$refs.uEditor.init(this.ruleForm.eventbaseinfo.eventdesp)
                    })
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        getView2() {
            this.setLoading(true)
            getProviderEventReleaseInfo({
                data: {eventid: this.eventid, eventtype: 10},
                success: data => {
                    this.setLoading(false)
                    if (data.data.enrollform) {
                        if (data.data.enrollform.length) this.showDistributionForm = true
                        data.data.enrollform.some((obj, index) => {
                            let tmp = []
                            obj.optionsinfo = obj.optionsinfo ? obj.optionsinfo.split(',') : []
                            obj.optionsinfo.forEach(obj2 => {
                                tmp.push({optionsName: obj2})
                            })
                            obj.optionsinfo = tmp
                        })
                    }
                    this.maxjoincoun = data.data.providersetting.maxjoincount
                    data.data.providersetting.maxjoincount = data.data.providersetting.maxjoincount ? data.data.providersetting.maxjoincount : ''
                    data.data.providersetting.ismodifyevent = !!data.data.providersetting.ismodifyevent
                    data.data.providersetting.ismodifyhostcontent = !!data.data.providersetting.ismodifyhostcontent
                    data.data.providersetting.issubnotify = !!data.data.providersetting.issubnotify
                    data.data.eventbaseinfo.eventid = this.eventid
                    this.ruleForm = data.data
                    this.pageshow = true
                    this.$nextTick(() => {
                        this.$refs.uEditor.init(this.ruleForm.eventbaseinfo.eventdesp)
                    })
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _setForm(obj) {
            let list = []
            let flag = true
            obj.enrollform.forEach(obj2 => {
                if (!obj2.colname) {
                    this.$message.error('请填写项目名称')
                    flag = false
                    return false
                }
                if (obj2.optionsinfo.length) {
                    let tmpList = []
                    obj2.optionsinfo.forEach(obj3 => {
                        if (!obj3.optionsName) {
                            this.$message.error('请添加选项内容')
                            flag = false
                            return false
                        } else {
                            tmpList.push(obj3.optionsName)
                        }
                    })
                    if (flag) {
                        obj2.optionsinfo = tmpList.join(',')
                    }
                } else if([6, 7, 8].indexOf(obj2.coltype) > -1 ) {
                    this.$message.error('请添加选项')
                    flag = false
                    return false
                } else {
                    obj2.optionsinfo = ''
                }
                if (flag) {
                    let tmp = {
                        colinnerid: obj2.colinnerid,
                        coltype: obj2.coltype,
                        colname:  obj2.colname,
                        isnotnull:  obj2.isnotnull, // 1必填 0 非必填
                        colindex:  obj2.colindex,
                        ispublic:  obj2.ispublic, // 0全部隐藏 1全部公开 1部分隐藏
                        optionsinfo: obj2.optionsinfo,
                        placeholder: obj2.placeholder,
                        publictype: obj2.publictype // 1 全部隐藏 全部公开 2部分隐藏
                    }
                    switch (obj2.ispublictype) {
                        case 1:
                            tmp.ispublic = 1
                            tmp.publictype = 1
                            break
                        case 2:
                            tmp.ispublic = 0
                            tmp.publictype = 1
                            break
                        case 3:
                            tmp.ispublic = 1
                            tmp.publictype = 2
                            break
                    }
                    list.push(tmp)
                }
            })
            obj.enrollform = list
            return flag
        },
        ...mapActions([
            'setLoading', 'setPage', 'setIsRefresh', 'setParams'
        ])
    },
    watch: {
        'ruleForm.isopeneventheader': {
            handler(newV, oldV) {
                if (newV) {
                    this.showService = true
                }
            }
        }
    },
    computed: {
        _computedTip() {
            let tip = ''
            if (this.ruleForm.brandsetting.shiptype==1) {
                tip = `已选择${this.ruleForm.brandsetting.headerlist.length}名团长`
            } else if (this.ruleForm.brandsetting.shiptype==2) {
                let list = this.ruleForm.brandsetting.ppidlist ? this.ruleForm.brandsetting.ppidlist.split(',') : []
                tip = `已选择${this.ruleForm.brandsetting.headerlist.length}名团长，${list.length}个提货点`
            } else if(this.ruleForm.brandsetting.shiptype==3) {
                let num = 0
                this.ruleForm.brandsetting.headerlist.forEach(obj => {
                    let tmp = obj.pplist ? obj.pplist.split(',') : []
                    num += tmp.length
                })
                tip = `已选择${this.ruleForm.brandsetting.headerlist.length}名团长，${num}个提货点`
            }
            return tip
        },
        ...mapGetters([ 'loading', 'brandBusiness', 'user', 'page'])
    },
    components: {
        UEditor, LeaderListDialog, ShopLocalCropper, AddrListDialog, LeaderAndAddrDialog, SuccessDialog, DistributionListDialog
    }
}
</script>
<style lang="scss">
@import "~common/scss/mixin";
@import "~common/scss/base";
.activityEdit.form {
    margin-top: 0 !important;
}
.activityEdit {
    background: #F5F7FA;
    min-width: 800px;
    .el-form-item__label{
        line-height: 24px;
        height: 40px;
        display: flex;
        align-items: center;
    }
    .resulttypetip{
        margin-left: 20px;
    }
    .title {
        padding-bottom: 20px;
        border-bottom: 1px solid #DCDFE6;
        p {
            border-left: 2px solid #409EFF;
            text-indent: 8px;
            font-size: 14px;
            font-weight: bold;
        }
    }
    .shareTitle {
        border: none;
    }
    .paster {
        margin-top: 40px;
        border: none;
        padding: 0;
    }
    .el-form {
        .el-form-item {
            .el-form-item__label {
                text-align: left;
                font-size: 14px;
            }
        }
        .inputTips {
            color: #C0C4CC;
            margin-left: 10px;
        }
    }
    .activityMsgBox {
        .left {
            min-width: 500px;
        }
    }
    .isRequired {
        .el-form-item__label::after {
            content: '*';
            color: #F56C6C;
            margin-left: 4px;
        }
    }
    .activityMsgBox {
        background: #fff;
        padding: 20px;
        margin-bottom: 24px;
        .contentBox {
            padding-top: 20px;
            display: flex;
            justify-content: space-between;
            max-width: 1400px;
            .left {
                min-width: 500px;
                .cover, .posterImg {
                    .el-form-item__content {
                        display: flex;
                        align-items: center;
                        .imgBox {
                            width: 318px;
                            height: 178px;
                            background: #F5F7FA;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            text-align: center;
                            .el-icon-picture, .el-icon-video-camera-solid {
                                color: #DCDFE6;
                                font-size: 40px;
                            }
                            .activityCoverImage {
                                width: 318px;
                                height: 178px;
                            }
                        }
                        .uploadFileBox {
                            margin-left: 12px;
                            .uploadFile {
                                .upload-demo {
                                    .el-upload {
                                        .el-button {
                                            background: #fff;
                                            color: #000;
                                            border: 1px solid #C0C4CC;
                                        }
                                    }
                                }
                            }
                            p {
                                color: #909399;
                                font-size: 14px;
                                line-height: 20px;
                            }
                        }
                    }
                }
                .disad {
                    .el-form-item__label::after {
                        content: '*';
                        color: #F56C6C;
                        margin-left: 4px;
                    }
                }

                .el-form-item {
                    .el-form-item__content {
                        .el-input {
                            width: 420px;
                        }
                        .el-date-editor {
                            .el-input__icon, .el-range-separator {
                                line-height: 25px;
                            }
                        }
                        .mostTips {
                            color: #C0C4CC;
                        }
                        .showRankingListTips {
                            color: #909399;
                            margin-left: 20px;
                            position: relative;
                            top: 2px;
                        }
                    }
                }
            }
            .right {
                width: 300px;
                height: 534px;
                background: rgba(242, 246, 252, 1);
                box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
                overflow: hidden;
                .innerBox {
                    width: 320px;
                    height: 482px;
                    overflow-y: scroll;
                    position: relative;
                    padding-bottom: 48px;
                    box-sizing: border-box;
                }
                .topBox {
                    height: 52px;
                    .top {
                        width: 300px;
                        height: 52px;
                    }
                }
                .coverImgBox {
                    background: #DCDCDC;
                    width: 300px;
                    height: 168px;
                    background-repeat: no-repeat !important;
                    background-size: 300px 168px !important;
                    position: relative;
                    .bg_bb_banner{
                        background: url('~common/images/brandBusiness/bg_banner.png');
                        position: absolute;
                        top:0;
                        left:0;
                        right:0;
                        bottom:0
                    }
                    .brandBusiness {
                        z-index: 2;
                        color: #fff;
                        position: absolute;
                        bottom:20px;
                        left:13px;
                        right:13px;
                        display: flex;
                        font-size: 12px;
                        .headerImg{
                            width: 40px;
                            height: 40px;
                            border-radius: 3px;
                            margin-right: 8px;
                        }
                        .brandBusinessinfo{
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            .hostname{
                                font-size: 12px;
                            }
                            .box{
                                font-size: 10px;
                            }
                        }
                    }
                }
                .eventinfo{
                    position: relative;
                    top: -10px;
                    margin: 0 13px;
                    background: #fff;
                    border-radius: 3px;
                    padding: 12px 8px;
                    width: 274px;
                    box-sizing: border-box;
                    .triangle{
                        position: absolute;
                        top: -8px;
                        left: 15px;
                        width: 0;
                        height: 0;
                        border-left: 4px solid transparent;
                        border-right: 4px solid transparent;
                        border-bottom: 10px solid #FFF;
                    }
                    .type{
                        font-size: 10px;
                        border: 1px solid  #409EFF;
                        border-radius: 2px;
                        padding: 4px;
                        color: #409EFF;
                        white-space: nowrap;
                        margin-right: 4px;
                    }
                    .box{
                        display: flex;
                        align-items: center;
                        overflow: hidden;
                    }
                    .time{
                        font-size: 10px;
                        margin-top: 8px;
                    }
                }
                .countdown{
                    background: #fff;
                    border-radius: 3px;
                    margin: 0 13px 8px 13px;
                    padding: 8px;
                    font-size: 10px;
                    display: flex;
                    align-items: center;
                    .day{
                        margin-right: 6px;
                    }
                    .hour,.minute,.second{
                        width: 16px;
                        height: 16px;
                        text-align: center;
                        line-height: 16px;
                        color: #fff;
                        background: #000;
                        margin: 0 6px;
                    }
                }
                .detailsBox {
                    margin: 0 13px;
                    border-radius: 3px;
                    font-size: 10px;
                    .detailsTitle {
                        background: #fff;
                        padding-left: 12px;
                        height: 40px;
                        line-height: 40px;
                        border-bottom: 1px solid #f5f5f5;
                    }
                    .detailsContent {
                        background: #fff;
                        padding: 12px;
                        overflow: hidden;
                        p {
                            width: 100%;
                            line-height: 15px;
                            text-indent: 0 !important;
                        }
                        img {
                            max-width: 100% !important;
                        }
                    }
                }
                .btns{
                    position: absolute;
                    bottom: 0;
                    left:0;
                    right: 0;
                    height: 40px;
                    background: url('~common/images/brandBusiness/bg_btns.png');
                    background-repeat: no-repeat !important;
                    background-size: 300px 40px !important;
                }
            }
        }
    }
    .title {
        .el-switch {
            margin-left: 22px;
        }
    }
    .date {
        .el-date-editor {
        }
        .el-form-item__label::after {
            content: '*';
            color: #F56C6C;
            margin-left: 4px;
        }
        .el-form-item__content {
            width: 500px;
            .to {
                margin: 0 13px;
            }
            .el-date-editor {
                width: 190px !important;
                .el-input__inner {
                    padding-right: 0;
                }
            }
        }
    }
    .disFrom {
        background: #fff;
        padding: 20px;
        margin-bottom: 24px;
        .title {
            .el-switch {
                margin-left: 22px;
            }
        }
        .contentBox {
            input {
                outline: none;
            }
            .optionsBox {
                margin-top: 20px;

                .flex {
                    display: flex;
                    align-items: center;
                }
                .tips {
                    color: #C0C4CC;
                    font-size: 14px;
                    margin-left: 18px;
                }
            }
            .formOptions {
                height: 60px;
                display: flex;
                width: 344px;
                border: 1px solid #D8DCE6;
                & > div {
                    flex: 1;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    line-height: 20px;
                    color: #606266;
                    .name {
                        margin-top: 8px;
                    }
                }
                img {
                    width: 20px;
                    height: 20px;
                }
            }
            .formItem {
                .input, .randio, .checkbox, .select {
                    position: relative;
                    width: 344px;
                    border: 1px solid #D8DCE6;
                    .optionsName {
                        input {
                            margin-left: 20px;
                        }
                    }
                    .choiceItem {
                        position: relative;
                        .delete {
                            position: absolute;
                            right: 12px;
                            bottom: 9px;
                            width: 50px;
                            height: 20px;
                            font-size: 12px;
                            text-align: center;
                            color: #606266;
                            border: 1px solid #C0C4CC;
                            line-height: 20px;
                            cursor: pointer;
                        }
                    }
                    & > div {
                        width: 344px;
                        height: 40px;
                        line-height: 40px;
                        padding: 0 10px;
                        box-sizing: border-box;
                        border-bottom: 1px solid #EEEEEE;
                    }
                    .newOptions {
                        color: #909399;
                    }
                }
                img {
                    width: 20px;
                    height: 20px;
                    position: absolute;
                    top: -10px;
                    right: -10px;
                }
            }
        }
    }

    .distributionMsgBox {
        background: #fff;
        padding: 20px;
        margin-bottom: 24px;
        .contentBox {
            margin-top: 20px;
            .openColonel {
                .el-switch {
                    margin-right: 15px
                }
                .el-icon-info {
                    margin-right: 15px;
                }
            }
            .earnings {
                .el-form-item__content {
                    display: flex;
                    align-items: center;
                    margin-left: 0 !important;
                    .el-radio-group {
                        line-height: 50px;
                    }
                    .balance {
                        font-size: 14px;
                        margin-left: 22px;
                        color: #909399;
                        position: relative;
                        top: -5px;
                        .balanceText {
                            color: #F56C6C;
                            margin-left: 5px;
                            margin-right: 10px;
                        }
                        .el-button {
                            width: 60px;
                            height: 24px;
                            font-size: 14px;
                            min-width: 60px;
                        }
                    }
                    .one {
                        margin-bottom: 15px;
                    }
                }
            }
            .el-form-item {
                .el-form-item__content {
                    .el-input {
                        width: 420px;
                    }
                    .bindclienttypeTips {
                        color: #909399;
                        line-height: 20px;
                    }
                    .el-icon-info {
                        margin-left: 5px;
                        margin-right: 16px;
                    }
                    .el-popover {

                    }
                }
            }
            .distributionGrade {
                .el-form-item__content {
                    .el-input-number {
                        width: 100px;
                        line-height: 32px;
                        .el-input-number__decrease, .el-input-number__increase {
                            width: 30px;
                            height: 30px;
                            border: none;
                            background: #409EFF;
                            color: #fff;
                        }
                        .el-input {
                            width: 100px;
                            .el-input__inner {
                                padding: 0;
                            }
                        }
                    }
                }
            }
            .showMore div {
                margin-left: 180px;
                width: 200px;
                line-height: 30px;
                text-align: center;
                border: 1px solid #D8DCE6;
                color: #909399;
                font-size: 14px;
            }
            .saleprice {
                .el-form-item__label::after {
                    content: '*';
                    color: #F56C6C;
                    font-size: 14px;
                    left: 3px;
                    position: relative;
                }
                .el-form-item__error {
                    top: 90%;
                }
            }
        }
    }
    .el-radio__input.is-checked + .el-radio__label {
        color: #303133;
    }
    .btnBox {
        .el-form-item__content {
            margin-left: 0 !important;
            text-align: center;
            background: #fff;
            height: 80px;
            line-height: 80px;
        }
    }

    .el-form-item {
        margin-bottom: 15px;
        .el-form-item__label {
            color: #36383A;
        }
        .el-input {
            height: 32px;
            .el-input__inner {
            }
        }
    }
    .uEditor .edui-default .edui-editor {
        max-width: 420px !important;
        height: 550px;
        .edui-editor-iframeholder {
            max-width: 420px !important;
        }
    }

    .uEditor {
        .content {
            .edui-default {
                .edui-default {
                    .view {
                        .view {
                            .main_content-LcrEruCc {
                                font-size: 14px;
                                img {
                                    max-width: 387px !important;
                                    height: 100% !important;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .shiptype{
        .el-radio-group{
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            .el-radio{
                height: 32px;
                line-height: 32px;
            }
            .el-radio + .el-radio{
                margin-top: 24px;
            }
            .el-button{
                margin-left: 20px;
            }
        }
        .el-button{
            padding: 0 10px;
        }
    }
    .el-icon-info {
        color: #C0C4CC;
        margin-left: 16px !important;
    }

    .haveUEditor {
        .el-form-item__error {
            top: 17%;
        }
        .uEditor {
            margin-top: 7px;
        }
    }
    .minordermoneyBox{
        .el-input{
            width: 200px !important;
            margin-right: 20px;
        }
    }
}
.tipsP {
    padding: 10px;
    p {
        line-height: 20px;
    }
}

</style>
